import { render, staticRenderFns } from "./StockPrintTicketTpl.vue?vue&type=template&id=56b982ba&scoped=true&"
import script from "./StockPrintTicketTpl.vue?vue&type=script&lang=js&"
export * from "./StockPrintTicketTpl.vue?vue&type=script&lang=js&"
import style0 from "./StockPrintTicketTpl.vue?vue&type=style&index=0&id=56b982ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b982ba",
  null
  
)

export default component.exports